import styled, { css } from 'styled-components';
import { colors, dimensions, typography } from '../../styles';
import { Input, FormLabel } from '../form/styles';

const tableHoverColor = '#FAFCFF';

const StyledTable = styled.table`
  ${props => css`
    width: 100%;
    max-width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    white-space: ${props.whiteSpace || ''};

    thead{
      display: table-header-group;
      border-bottom: 1px solid #D6D6D6;
      // background-color: rgb(243, 244, 246);
    }

    th{
      padding: 15px 20px !important;
      color: ${colors.themeBlue} !important;
      font-size: 14px !important;
      font-weight: 600;
    }

      
    th,
    td {
      // border-top: 1px solid ${colors.borderPrimary};
      border: none;
      color: ${colors.textPrimary};
      padding: ${dimensions.unitSpacing}px;
      display: table-cell;
      vertical-align: ${props.alignTop && 'top'};
      font-size: 14px;
      text-align: center;

      & ${FormLabel}, & ${Input} {
        margin: 0px;
      }
    }

    thead {
      th,
      td {
        text-transform: uppercase;
        color: ${colors.colorCoreLightGray};
        font-size: ${typography.fontSizeUppercase}px;
        // text-align: center;
      }
    }
 
    tr:nth-of-type(even) td {
      background: #FAFCFF;
    }

    ${
      props.hover
        ? `tr:hover td { background-color: ${tableHoverColor}; cursor: pointer; }`
        : null
    } ${props.bordered ? `th, td { border-bottom: none; }` : null} ${
    props.striped
      ? `tr:nth-of-type(odd) td { background-color: ${colors.bgUnread}; }`
      : null
  } th {
      border-top: none;
    }

    th:first-child,
    td:first-child {
      border-left: none;
    }

    th:last-child,
    td:last-child {
      border-right: none;
      // text-align: right;
    }

    @media (min-width: 1170px) {
      th,
      td {
        padding: ${dimensions.unitSpacing}px ${dimensions.coreSpacing}px;
      }
    }
  `};
`;

export default StyledTable;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/table/styles.js